// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"ReviewSummaryAvatars_avatarContainer__jz9oj","avatar":"ReviewSummaryAvatars_avatar__BHlAF"};